import React from 'react'
import { GetIcon } from '../../../../../icons'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom';

const BackToOverview = ({user}) => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    
  return (
    <div style={{backgroundColor: '#3FC4FD'}}>
        <div style={{display:'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 30px', color: '#FFFFFF'}}>
            <div style={{display:'flex', gap: '10px', alignItems: 'center'}}>
                <GetIcon icon={"key"} fontSize='30px' color='#FFFFFF' />
                <span>{`${t("You work on behalf of")} ${user.companyName}`}</span>
            </div>
            <div onClick={()=> navigate("/partner/company")} style={{padding: '5px 10px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px', border: '1px solid #FFFFFF'}}>
                <GetIcon icon={"left-arrow"} fontSize='30px' color='#FFFFFF' />
                {t("Back to overview")}
            </div>
        </div>
    </div>
  )
}

export default BackToOverview